let ContentRoot = process.env.VUE_APP_ATRIUM;

const ContentPaths = {
  icons: "content/icons/"
};

const MapIcons = {
  info: "prime-information-outline.png",
  heavyUser: "prime-factory.png",
  leakFound: "prime-pipe-leak.png",
  BTBBleak: "prime-BTBB-leak.png",
  otherFound: "prime-help-rhombus-outline.png",
  PRV: "prime-gauge-empty.png",
  investigationArranged: "prime-magnify.png",
  repairArranged: "prime-wrench.png",
  alert: "prime-alert-outline.png",
  poi: "poi-prime.png",
  poiGroup: "poi-group-prime.png"
};

const AlertMapIcons = {
  info: "alert-information-outline.png",
  heavyUser: "alert-factory.png",
  leakFound: "alert-pipe-leak.png",
  BTBBleak: "alert-BTBB-leak.png",
  otherFound: "alert-help-rhombus-outline.png",
  PRV: "alert-gauge-empty.png",
  investigationArranged: "alert-magnify.png",
  repairArranged: "alert-wrench.png",
  alert: "alert-alert-outline.png",
  poi: "poi-red.png",
  poiGroup: "poi-group-red.png"
};

const OrangeMapIcons = {
  info: "orange-information-outline.png",
  heavyUser: "orange-factory.png",
  leakFound: "orange-pipe-leak.png",
  BTBBleak: "orange-BTBB-leak.png",
  otherFound: "orange-help-rhombus-outline.png",
  PRV: "orange-gauge-empty.png",
  investigationArranged: "orange-magnify.png",
  repairArranged: "orange-wrench.png",
  alert: "orange-alert-outline.png",
  poi: "poi-orange.png",
  poiGroup: "poi-group-orange.png"
};

export { ContentRoot, ContentPaths, MapIcons, AlertMapIcons, OrangeMapIcons };
